import request from '@/utils/request'
export const loginApi = (data) => {
    return request({
        url: 'Users/adminLogin',
        method: 'post',
        data: data,
    })
}

export const resolveTenantApi = (code) => {
    return request({
        url: 'Tenants/resolve',
        method: 'get',
        params: { code }
    })
}

export const changePwdApi = (data) => {
    return request({
        url: 'Users/setPass',
        method: 'post',
        data: data,
    })
}